import { render, staticRenderFns } from "./ActiveGymComp.vue?vue&type=template&id=ac506b58&scoped=true"
import script from "./ActiveGymComp.vue?vue&type=script&lang=js"
export * from "./ActiveGymComp.vue?vue&type=script&lang=js"
import style0 from "./ActiveGymComp.vue?vue&type=style&index=0&id=ac506b58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac506b58",
  null
  
)

/* custom blocks */
import block0 from "./ActiveGymComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports